const stripTags = require("./stripTags.js");
module.exports = function convertToPlainText(text, divider = "\n"){
    return stripTags(text.replace(/<\/p>/gmi, divider)).trim();
}